// extracted by mini-css-extract-plugin
export default {"title":"VerifyEmailModal_title__nypFa","text":"VerifyEmailModal_text__mB6G7","dashboardModalBody":"VerifyEmailModal_dashboardModalBody__Sm9vx"};